import React from 'react';
import { file_url } from 'constant/url';
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';

const AppIntro = () => {
    const { t } = useTranslation();
    const introData = useSelector(state => state?.common?.common_content);
    return (
        <>
            <h1 className="medium_font mb-3">{t("settings.app_intro.intro_text")}</h1>
            <dt className="small_font fw-medium mb-3" style={{ color: 'var(--text-gray)' }}>{introData?.intro_media?.description}</dt>
            <video
                src={`${file_url}${introData?.intro_media?.link}`}
                className="video_style w-100 h-auto"
                autoPlay={true}
                muted
                // loop
                controls
            >
                <track kind="captions" />
            </video>
        </>
    )
}

export default AppIntro;